<template>
  <WizardContent
    :graphic="{
      type: 'gradient',
      assetsPath: 'image-terminated',
    }"
  >
    <h4 class="mt-6 mt-9">
      Your account has been disabled.
    </h4>
    <p class="p3">
      We're sorry{{ firstName ? ` ${firstName}` : '' }}, but it looks like this account has been disabled
      by your JobNav Administrator or your ATS.
      We recommend reaching out to the JobNav Administrator at your organization
      to request activation.

      If you believe this is an error, reach out to our support team at
      <a href="mailto:support@datapeople.io?subject=Account%20disabled%20on%20JobNav">
        support@datapeople.io
      </a>
    </p>
  </WizardContent>
</template>

<script>
import WizardContent from '@/components/shared/WizardContent.vue';
import { mapState } from 'pinia';
import { useWizard } from '@/stores/wizard/wizard';

export default {
  name: 'DisabledUser',
  components: {
    WizardContent,
  },
  emits: ['track-page-load'],
  computed: {
    ...mapState(useWizard, ['firstName']),
  },
  beforeCreate() {
    this.$emit('track-page-load', { page: 'Disabled User' });
  },
};
</script>
